import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class IntraOne_ds_get_primary_pick_location_by_material_id_packaging_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { material_id: number, packaging_id?: number }): 
  Promise<{ result: { Id?: number, LocationId?: number, MaterialId?: number, PackagingId?: number, Location?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.material_id)) {
      $missingRequiredInParams.push('\'material_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_primary_pick_location_by_material_id_packaging_id/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { material_id: number, packaging_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LocationId?: number, MaterialId?: number, PackagingId?: number, Location?: { Name?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.material_id)) {
      $missingRequiredInParams.push('\'material_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_primary_pick_location_by_material_id_packaging_id/getList`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { material_id: number, packaging_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LocationId?: number, MaterialId?: number, PackagingId?: number, Location?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.material_id)) {
      $missingRequiredInParams.push('\'material_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_primary_pick_location_by_material_id_packaging_id/getByKeys`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      material_id: number, packaging_id?: number    }) {
        if(isNil($inParams.material_id)) {
          return true; 
        }
      return false;
    }
}
